module.exports = __webpack_public_path__ + "static/media/image2.a89c36bc.jpg";